import { z } from 'zod';

export const CustomBaseConfiguration = z.object({
  kind: z.literal('CustomBase'),
  name: z.string(),
  position: z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
  }),
  rotation: z.object({
    roll: z.number(),
    pitch: z.number(),
    yaw: z.number(),
  }),
});

export type CustomBaseConfiguration = z.infer<typeof CustomBaseConfiguration>;

export const CustomBaseState = CustomBaseConfiguration;

export type CustomBaseState = z.infer<typeof CustomBaseState>;
